<video class="videoPlayerFullModal" #videoPlayer width="100%" height="100%" controls autoplay>
    <source src="../../assets/video/iphoneVideo.mp4" type="video/mp4">
</video>